export { default } from './IconFactGridBlock';
